/* ==========================================================================
   CL · Hero Dark (Slider) — comportamiento
   - Inicializa Swiper (que el tema ya carga en theme.liquid) con las
     mismas opciones que el slideshow de Force: autoplay, retardo,
     velocidad, loop, pausa al hover, flechas y bullets.
   - Con un solo slide no se inicializa Swiper (render estático), pero
     los videos SÍ se gestionan igual.
   - Videos: solo se reproduce el VISIBLE del slide activo. La media del
     otro dispositivo (display:none) se pausa — un <video> oculto por
     CSS sigue decodificando si no se pausa, y eso hacía que el hero se
     trabara en desktop (dos videos decodificando a la vez).
   - Al cambiar de slide, el video entrante arranca al INICIO de la
     transición (no al final) para que no se vea congelado mientras
     entra; los demás se pausan al terminar.
   - Tras cargar la página, los videos pasan a preload="auto" para que
     los slides siguientes ya tengan buffer al llegar su turno.
   ========================================================================== */

(function () {
	'use strict';

	/* En Swiper con loop, el clon del slide activo también debe verse
	   reproduciéndose (versiones antiguas usan -duplicate-active). */
	var ACTIVE_SEL = '.swiper-slide-active, .swiper-slide-duplicate-active';

	function isVisible(el) {
		return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
	}

	function getActiveSlides(root) {
		var slides = root.querySelectorAll(ACTIVE_SEL);
		if (slides.length) return [].slice.call(slides);
		/* Sin Swiper (un solo slide): el primero es el activo */
		var first = root.querySelector('.swiper-slide');
		return first ? [first] : [];
	}

	function playActive(root) {
		getActiveSlides(root).forEach(function (slide) {
			slide.querySelectorAll('video').forEach(function (video) {
				if (!isVisible(video)) {
					/* media del otro dispositivo: oculta pero decodificando */
					video.pause();
					return;
				}
				var playing = video.play();
				if (playing && playing.catch) playing.catch(function () {});
			});
		});
	}

	function pauseInactive(root) {
		var actives = getActiveSlides(root);
		root.querySelectorAll('.swiper-slide video').forEach(function (video) {
			var slide = video.closest('.swiper-slide');
			if (actives.indexOf(slide) !== -1) return;
			video.pause();
		});
	}

	function syncVideos(root) {
		pauseInactive(root);
		playActive(root);
	}

	function setupVideos(root, swiperEl) {
		if (root.dataset.clVideos === 'true') return;
		root.dataset.clVideos = 'true';

		syncVideos(swiperEl);

		/* Al cruzar el breakpoint cambia qué media es visible */
		var resizeTimer;
		window.addEventListener(
			'resize',
			function () {
				window.clearTimeout(resizeTimer);
				resizeTimer = window.setTimeout(function () {
					syncVideos(swiperEl);
				}, 150);
			},
			{ passive: true }
		);

		/* Con la página ya cargada, llena el buffer de todos los videos
		   para que el cambio de slide no entre con el buffer vacío. */
		function warmVideos() {
			swiperEl.querySelectorAll('video').forEach(function (video) {
				video.preload = 'auto';
			});
		}
		if (document.readyState === 'complete') {
			warmVideos();
		} else {
			window.addEventListener('load', warmVideos, { once: true });
		}
	}

	function initHeroSlider(root) {
		if (!root || root.dataset.clInit === 'true') return;
		root.dataset.clInit = 'true';

		var swiperEl = root.querySelector('.cl-hero-slider__swiper');
		if (!swiperEl) return;

		var count = parseInt(root.dataset.slideCount, 10) || 0;

		/* Los videos se gestionan siempre, aunque haya un solo slide */
		setupVideos(root, swiperEl);

		if (count < 2) return;

		if (typeof window.Swiper === 'undefined') {
			// Swiper aún no cargó (script defer): reintenta al terminar la carga
			window.addEventListener('load', function () {
				root.dataset.clInit = 'false';
				initHeroSlider(root);
			}, { once: true });
			return;
		}

		var hoverStop = root.dataset.hoverStop === 'true';
		var autoplay = false;
		if (root.dataset.autoplay === 'true') {
			autoplay = {
				delay: parseInt(root.dataset.delay, 10) || 5000,
				disableOnInteraction: false,
				pauseOnMouseEnter: hoverStop
			};
		}

		var config = {
			loop: root.dataset.loop === 'true',
			speed: parseInt(root.dataset.speed, 10) || 1100,
			autoplay: autoplay,
			pagination: false,
			navigation: false
		};

		var paginationEl = root.querySelector('.cl-hero-slider__pagination');
		if (paginationEl) {
			config.pagination = { el: paginationEl, clickable: true };
		}

		var prevEl = root.querySelector('.cl-hero-slider__arrow--prev');
		var nextEl = root.querySelector('.cl-hero-slider__arrow--next');
		if (prevEl && nextEl) {
			config.navigation = { prevEl: prevEl, nextEl: nextEl };
		}

		var swiper = new window.Swiper(swiperEl, config);

		/* El video entrante arranca al inicio de la transición… */
		swiper.on('slideChange', function () {
			playActive(swiperEl);
		});
		/* …y al terminar se pausa todo lo que no sea el slide activo */
		swiper.on('slideChangeTransitionEnd', function () {
			syncVideos(swiperEl);
		});
		syncVideos(swiperEl);
	}

	function initAll() {
		document.querySelectorAll('.cl-hero-slider').forEach(initHeroSlider);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('shopify:section:load', initAll);
})();
